import { render } from "./organisation-contracts.vue?vue&type=template&id=58a84f83&scoped=true"
import script from "./organisation-contracts.vue?vue&type=script&lang=js"
export * from "./organisation-contracts.vue?vue&type=script&lang=js"

import "./organisation-contracts.vue?vue&type=style&index=0&id=58a84f83&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a84f83"]])

export default __exports__